
import React, { useContext, useEffect, useState } from "react";
import { Form,FormGroup,Input,Container } from "semantic-ui-react";
import { AgGridReact } from "ag-grid-react/lib/agGridReact";
import { observer } from "mobx-react-lite";
import WorkOrderStore from "../../../../app/stores/workorderStore";

interface IProps {}


const AppointmentGrid: React.FC<IProps> = () => {
  const workorderStore = useContext(WorkOrderStore);
  const { selectedWorkOrderAppointment: Curapps } = workorderStore;
  const [apps, setAppList] = useState([{}]);
  const { selectedWorkOrder: workorder } = workorderStore;

  useEffect(() => {
    if (workorder != null) {
      setAppList(Curapps);
    }
  }, [Curapps,workorder]);

  return (
    <Container>
      <Form widths="equal">
                <FormGroup>
                  <Form.Field>
                    <Input
                      value={workorder.ClientRef}
                      readonly
                      label="Site Consideration"
                      size="mini"
                      placeholder="Site Consideration"
                      fluid
                    />
                  </Form.Field>
                </FormGroup>
      </Form>
      <div
        className="ag-theme-material"
        style={{ height: "200px", width: "100%" }}
      >
        <AgGridReact
          enableColResize={true}
          enableSorting={true}
          colResizeDefault={true}
          columnDefs={SorCols}
          rowData={apps}
        />
      </div>
    </Container>
  );
};

const SorCols = [
  {
    headerName: "Status",
    field: "BookingStatus",
    width: 150
  },
  { headerName: "Resource Name", field: "ResourceName", width: 200 },
  { headerName: "Start Time", 
    field: "StartTime",
    valueFormatter: dateFormatterNoDaylight,filter:true,suppressMenu:true, width: 200 },
  {
    headerName: "End Time",
    field: "EndTime",
    valueFormatter: dateFormatterNoDaylight,filter:true,suppressMenu:true,
    width: 200,

  }
];

function dateFormatter(params:any) {
  var date = new Date(params.value);
  return date.toLocaleString();
}

function dateFormatterNoDaylight(params:any) {
  if(params.value){
    var formatdate = (params.value).replace("T", " ").replace("Z", "");
    return formatdate.toString();
  }
  else{
    return (params.value);
  }
}



export default observer(AppointmentGrid);
